<template>
    <common-page flex-column>
        <div class="position-sticky top p-2 title d-flex">
            隐患发现
            <b-button v-if="currentLoginName" class="ml-auto"
                      :variant="filterMyself?'primary':'outline-secondary'"
                      @click="triggerFilterMyself">
                <i class="fa-solid fa-filter"></i>
            </b-button>
        </div>
        <div class="w-100 position-relative flex-grow-1">
            <pull-to-refresh ref="scroll"
                             @refresh="getRemoteData(true)"
                             @infinite="getRemoteData(false)">
                <template v-for="(item, index) of hazardList">
                    <div :key="index" class="card mt-1 mr-1 ml-1" style="height: 45px">
                        <b-button class="d-flex flex-row align-content-center w-100 h-100" variant="light"
                                  v-b-toggle.detail @click="currentItem = item">
                            <b-badge variant="light" pill class="m-tb-auto">
                                {{ namedDate(item.createdTime) }}
                            </b-badge>
                            <span class="ml-1 m-tb-auto text-secondary">{{ item.createdByName }}</span>
                            <span class="ml-1 m-tb-auto" style="font-weight: 900">
                                安全员点位：{{ positionMap[item.position] }}</span>
                            <b-badge class="ml-auto m-tb-auto" :variant="STATUS[item.processStatus].variant">
                                {{ STATUS[item.processStatus].text }}
                            </b-badge>
                            <b-badge variant="light" pill class="ml-1 m-tb-auto">
                                >
                            </b-badge>
                        </b-button>
                    </div>
                </template>
                <empty-list-info v-if="hasQueried && hazardList.length===0"></empty-list-info>
            </pull-to-refresh>
        </div>

        <b-sidebar id="detail" ref="detail" sidebar-class="w-90"
                   body-class="position-relative"
                   right backdrop shadow @hidden="currentItem=null">
            <template v-if="currentItem">
                <b-button v-if="currentLoginName === currentItem.createdBy && routeTag === 1 && !editMyHazard"
                          class="position-absolute right top m-2" variant="outline-primary"
                          @click="editMyHazard = true">
                    Edit
                </b-button>
                <hazard-detail v-if="!editMyHazard" :current-item="currentItem"></hazard-detail>
                <hazard-common-edit v-else title="编辑" :item="currentItem" type="new"
                                    @success="whenEditMySuccess"></hazard-common-edit>

                <hazard-common-edit v-if="routeTag===0" :item="currentItem" title="码上改" type="rectify"
                                    @success="whenEditSuccess(2)"></hazard-common-edit>
                <hazard-common-edit v-else-if="routeTag===3 && currentItem.processStatus!==3" :item="currentItem"
                                    title="审核" type="review"
                                    @success="whenEditSuccess(3)"></hazard-common-edit>
            </template>
        </b-sidebar>
    </common-page>
</template>

<script>
import PullToRefresh from "@/components/wx/PullToRefresh.vue";
import {getNamedDate} from "@/components/wx/TimeUtil";
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import HazardDetail from "@/views/mobile/sithMesII/ehs/hazard/HazardDetail.vue";
import HazardCommonEdit from "@/views/mobile/sithMesII/ehs/hazard/HazardCommonEdit.vue";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo.vue";
import {mapState} from "vuex";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "HazardList",
    components: {EmptyListInfo, HazardCommonEdit, HazardDetail, CommonPage, PullToRefresh,},
    mixins: [emCommonUtilMixin],
    data() {
        return {
            hazardList: [],
            currentPage: 0,
            pageSize: 20,
            positionMap: {},

            currentItem: null,

            STATUS: {
                1: {variant: 'danger', text: '待整改'},
                2: {variant: 'warning', text: '待审核'},
                3: {variant: 'success', text: '已整改'},
            },
            hasQueried: false,

            filterMyself: false,
            editMyHazard: false,
        }
    },
    computed: {
        ...mapState({
            currentLoginName: (state, getters) => getters["userStore/currentLoginName"],
        }),
        /*
        0: 待整改列表，码上改
        1: 待整改列表，查看，可编辑自己
        2: 已整改列表，查看
        3: 已整改未审核列表，审核
         */
        routeTag() {
            let tag = this.$route.query.tag;
            if (tag) {
                return Number.parseInt(tag);
            }
            return tag;
        },
    },
    mounted() {
        // this.getRemoteData(true);
        this.$refs.scroll && this.$refs.scroll.refresh();
        this.getPositionMap();
    },
    methods: {
        getRemoteData(refresh = true) {
            if (refresh) {
                this.currentPage = 0;
            } else {
                this.currentPage++;
            }
            let temp;
            if (this.routeTag <= 1) {
                temp = {processStatusLte: 1};
            } else if (this.routeTag === 3) {
                temp = {processStatus: 2};
            } else {
                temp = {processStatusGte: 2};
            }
            if (this.filterMyself) {
                temp.createdByEq = this.currentLoginName;
            }
            this.$query({
                key: 'hazard_list',
                page: {
                    pageNumber: this.currentPage,
                    pageSize: this.pageSize,
                    orders: [{field: 'createdTime', direction: 'DESC'}]
                },
                where: temp
            }).then(res => {
                if (res && res.data && res.data.length > 0) {
                    let list = res.data;
                    if (refresh) {
                        this.hazardList = list;
                    } else {
                        for (let item of list) {
                            this.hazardList.push(item);
                        }
                    }
                } else {
                    if (refresh) {
                        this.hazardList = [];
                    } else {
                        this.$refs.scroll.loadComplete(true);
                    }
                }
            }).finally(() => {
                if (refresh) {
                    this.$refs.scroll.refreshDone();
                } else {
                    this.$refs.scroll.infiniteDone();
                }
                this.hasQueried = true;
            });
        },
        namedDate(time) {
            return getNamedDate(time);
        },
        getPositionMap() {
            this.$store.dispatch('dictionaryEnumStore/getDict', 'ehs_hazard_position')
                .then(list => {
                    let temp = {};
                    for (let item of list) {
                        temp[item.value] = item.label;
                    }
                    this.positionMap = temp;
                })
        },
        whenEditSuccess(status) {
            this.currentItem.processStatus = status;
            this.$refs.detail.hide();
        },

        triggerFilterMyself() {
            this.filterMyself = !this.filterMyself;
            this.getRemoteData();
        },
        whenEditMySuccess(form) {
            console.log('form', form);
            this.copyObj2Obj(form, this.currentItem, true);
            this.$refs.detail.hide();
            this.editMyHazard = false;
        },
    }
}
</script>

<style scoped>
.title {
    font-size: 1.2rem;
    font-weight: bold;
}
</style>
